import React from 'react';
import { Users } from 'lucide-react';

// Sizes are multiples of 20 (one ScaleSerp page); sizes above the balance are disabled.
function ResultSizeSelect({ value, onChange, balance, max }) {
  const sizes = [];
  for (let s = 20; s <= max; s += 20) sizes.push(s);
  const known = typeof balance === 'number';

  return (
    <div className="size-field">
      <label htmlFor="result-size-select" className="size-field-label">
        <Users size={14} />
        How many prospects?
      </label>
      <select
        id="result-size-select"
        className="size-field-select"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
      >
        {sizes.map((s) => (
          <option key={s} value={s} disabled={known && s > balance}>
            Up to {s}{known && s > balance ? ' (not enough credits)' : ''}
          </option>
        ))}
      </select>
      <div className="size-field-help">
        <p>
          Uses up to <strong>{value} credits</strong>
          {known ? <> · you have <strong>{balance.toLocaleString()}</strong></> : null}.
        </p>
        <p>
          1 credit per new prospect found with a real email or a phone; a guessed-only email and duplicates are free.
        </p>
      </div>
    </div>
  );
}

export default ResultSizeSelect;
